import * as z from 'zod'

export const InstagramSchema = z.object({
	username: z.string().nonempty(),
	alias: z.string().optional()
})

export type InstagramType = z.TypeOf<typeof InstagramSchema>